import { useState, createContext, useContext, useRef } from "react";

export const useGroupCertificationModalState = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isModalLoading, setIsModalLoading] = useState<boolean>(false);
  const [siteId, setSiteId] = useState<number>();
  const [startDate, setStartDate] = useState<Date>();

  const handleModalClose = () => {
    resolveModal(false);
  };

  const resolverRef = useRef<((confirmed: boolean) => void) | null>(null);

  const openModalAndWait = (siteId: number, startDate: Date): Promise<boolean> => {
    setSiteId(siteId);
    setStartDate(startDate);
    setIsModalOpen(true);
    return new Promise((resolve) => {
      resolverRef.current = resolve;
    });
  };

  const resolveModal = (confirmed: boolean) => {
    setIsModalOpen(false);
    resolverRef.current?.(confirmed);
    resolverRef.current = null;
  };

  return {
    isModalOpen,
    handleModalClose,
    isModalLoading,
    setIsModalLoading,
    openModalAndWait,
    resolveModal,
    siteId,
    startDate,
  };
};

export const GroupCertificationModalContext = createContext<ReturnType<typeof useGroupCertificationModalState> | null>(
  null,
);

export const GroupCertificationModalContextProvider = ({ children }: { children: React.ReactNode }) => {
  const {
    isModalOpen,
    handleModalClose,
    isModalLoading,
    setIsModalLoading,
    openModalAndWait,
    resolveModal,
    siteId,
    startDate,
  } = useGroupCertificationModalState();

  return (
    <GroupCertificationModalContext.Provider
      value={{
        isModalOpen,
        handleModalClose,
        isModalLoading,
        setIsModalLoading,
        openModalAndWait,
        resolveModal,
        siteId,
        startDate,
      }}
    >
      {children}
    </GroupCertificationModalContext.Provider>
  );
};

export const useGroupCertificationModalContext = () => {
  const context = useContext(GroupCertificationModalContext);
  if (context === null) {
    throw "useGroupCertificationModalContext called outside of context";
  }
  return context;
};
